import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import dayjs from 'dayjs';
import { message } from 'ant-design-vue';
import { copy } from '@/common';
import { useComplaintMeta } from './useComplaintMeta';
import { useComplaintUiState } from './useComplaintUiState';
import { useWechatComplaint } from './useWechatComplaint';
const shipStatusMap = {
  '0': '未下发',
  '10': '已下发',
  '11': '待复送',
  '12': '已回收'
};
const formatShipStatus = value => value == null ? '-' : shipStatusMap[String(value)] || '-';
export const usePage = () => {
  const meta = useComplaintMeta();
  const complaint = useWechatComplaint();
  const ui = useComplaintUiState(() => {
    var _complaint$currentCom, _complaint$selectedRo;
    return ((_complaint$currentCom = complaint.currentComplaint.value) === null || _complaint$currentCom === void 0 ? void 0 : _complaint$currentCom.complaintMainId) || ((_complaint$selectedRo = complaint.selectedRows.value[0]) === null || _complaint$selectedRo === void 0 ? void 0 : _complaint$selectedRo.complaintMainId);
  });
  const {
    filterForm,
    loading,
    submitLoading,
    dataSource,
    total,
    pageNum,
    pageSize,
    selectedRows,
    selectedRowKeys,
    currentComplaint,
    detailLoading,
    merchantOptions,
    productOptions,
    problemOptions,
    overviewList,
    getList,
    search,
    reset,
    selectRows,
    openDetail,
    clearDetail,
    exportList,
    reply,
    resend,
    refund,
    rejectRefund,
    batchSubmit,
    getFilterOptions,
    getStatistics,
    getProductOptions,
    getQuickReplyTemplates
  } = complaint;
  const {
    columns,
    quickRanges,
    refundReasons,
    toMoney,
    problemTypeMap,
    refundStateMap,
    complaintStateMap,
    refundStateOptions,
    complaintStateOptions
  } = meta;
  const replyTemplates = computed(() => complaint.replyTemplates.value);
  const filterOptions = computed(() => ({
    problemOptions: problemOptions.value,
    complaintStateOptions,
    refundStateOptions,
    merchantOptions: merchantOptions.value,
    productOptions: productOptions.value
  }));
  const historyList = computed(() => {
    var _currentComplaint$val;
    return [...(((_currentComplaint$val = currentComplaint.value) === null || _currentComplaint$val === void 0 ? void 0 : _currentComplaint$val.history) || [])].sort((a, b) => dayjs(a.operateTime).valueOf() - dayjs(b.operateTime).valueOf());
  });
  const orderInfoList = computed(() => {
    const item = currentComplaint.value;
    return [{
      label: '商户单号',
      value: item === null || item === void 0 ? void 0 : item.linkedOrderNo,
      copy: true
    }, {
      label: '商店名称',
      value: item === null || item === void 0 ? void 0 : item.storeName
    }, {
      label: '被诉产品',
      value: item === null || item === void 0 ? void 0 : item.productDisplayName
    }, {
      label: '商品名称',
      value: item === null || item === void 0 ? void 0 : item.goodsName
    }, {
      label: '订单金额',
      value: item !== null && item !== void 0 && item.amount ? `¥${toMoney(item.amount)}` : '-',
      danger: true
    }, {
      label: '支付状态',
      value: item === null || item === void 0 ? void 0 : item.payStatus
    }, {
      label: '支付时间',
      value: item === null || item === void 0 ? void 0 : item.payTime
    }, {
      label: '下发时间',
      value: item === null || item === void 0 ? void 0 : item.shipTime
    }, {
      label: '道具状态',
      value: formatShipStatus(item === null || item === void 0 ? void 0 : item.shipStatus)
    }, {
      label: '设备 ID',
      value: item === null || item === void 0 ? void 0 : item.deviceId,
      copy: true
    }];
  });
  const refundDisabledTip = computed(() => {
    const item = currentComplaint.value;
    if (!(item !== null && item !== void 0 && item.payTime)) return '';
    if (['refunded', 'REFUNDED'].includes(item.refundState || '')) return '订单已退款，无需重复退款';
    if (['approving', 'APPROVING'].includes(item.refundState || '')) return '退款审批中，请勿重复发起';
    if (['failed', 'FAILED'].includes(item.refundState || '')) return '';
    return dayjs().diff(dayjs(item.payTime), 'day') > 365 ? '该订单已过期，不支持退款' : '';
  });
  const handleOpenDetail = async record => {
    ui.detailOpen.value = true;
    await openDetail(record);
  };
  const closeDetail = () => {
    ui.detailOpen.value = false;
    ui.replyContent.value = '';
    ui.revokeReplyFiles();
    ui.resendText.value = '复送';
    clearDetail();
  };
  const changePage = (page, size) => {
    pageNum.value = page;
    pageSize.value = size;
    getList(true);
  };
  const submitReply = async () => {
    if (ui.replyFiles.value.some(item => item.status === 'uploading')) return message.warning('图片上传中，请稍后再提交');
    if (ui.replyFiles.value.some(item => item.status === 'error')) return message.warning('存在上传失败的图片，请删除后重新上传');
    const imageMediaIds = ui.replyFiles.value.map(item => {
      var _item$response;
      return (_item$response = item.response) === null || _item$response === void 0 ? void 0 : _item$response.mediaId;
    }).filter(mediaId => !!mediaId);
    const done = await reply(ui.replyContent.value, imageMediaIds);
    if (done) {
      ui.replyContent.value = '';
      ui.revokeReplyFiles();
    }
  };
  const submitResend = async () => {
    ui.resending.value = true;
    try {
      const done = await resend();
      if (done && currentComplaint.value) {
        currentComplaint.value = {
          ...currentComplaint.value,
          reshipStatus: '10'
        };
      }
    } finally {
      ui.resending.value = false;
    }
  };
  const openRefund = () => {
    var _currentComplaint$val2, _currentComplaint$val3;
    ui.refundAmount.value = Number(((_currentComplaint$val2 = currentComplaint.value) === null || _currentComplaint$val2 === void 0 ? void 0 : _currentComplaint$val2.applyRefundAmount) || ((_currentComplaint$val3 = currentComplaint.value) === null || _currentComplaint$val3 === void 0 ? void 0 : _currentComplaint$val3.amount) || 0);
    ui.refundReason.value = '';
    ui.revokeRefundScreenshots();
    ui.refundOpen.value = true;
  };
  const submitRefund = async () => {
    var _currentComplaint$val4;
    if (!ui.refundAmount.value || ui.refundAmount.value > Number(((_currentComplaint$val4 = currentComplaint.value) === null || _currentComplaint$val4 === void 0 ? void 0 : _currentComplaint$val4.amount) || 0)) return message.warning('请输入有效退款金额');
    const screenshotUrls = ui.refundScreenshots.value.filter(f => f.status === 'done').map(f => f.url).filter(Boolean);
    if (await refund(ui.refundAmount.value, ui.refundReason.value, screenshotUrls)) ui.refundOpen.value = false;
  };
  const submitReject = async () => {
    if (await rejectRefund('')) ui.rejectOpen.value = false;
  };
  // 批量操作目标行：与勾选状态解耦，承载经 canRefund/canReply/canComplete 过滤后的子集
  const batchTargetRows = ref([]);
  const batchRefundTotalAmount = computed(() => batchTargetRows.value.reduce((total, item) => total + Number(item.amount || 0), 0));
  const openBatch = (type, rows = []) => {
    ui.batchType.value = type;
    ui.batchRefundMode.value = 'full';
    ui.batchRefundRatio.value = undefined;
    ui.batchRefundReason.value = '';
    ui.batchReplyContent.value = '';
    ui.revokeBatchReplyFiles();
    if (type === 'refund') ui.revokeRefundScreenshots();
    batchTargetRows.value = rows;
    ui.batchOpen.value = true;
  };
  const submitBatch = async () => {
    if (ui.batchType.value === 'reply' && ui.batchReplyContent.value.trim().length < 10) return;
    if (ui.batchType.value === 'reply' && ui.batchReplyFiles.value.some(item => item.status === 'uploading')) return message.warning('图片上传中，请稍后再提交');
    if (ui.batchType.value === 'reply' && ui.batchReplyFiles.value.some(item => item.status === 'error')) return message.warning('存在上传失败的图片，请删除后重新上传');
    if (ui.batchType.value === 'refund' && ui.batchRefundMode.value === 'ratio' && !ui.batchRefundRatio.value) return;
    if (ui.batchType.value === 'refund' && !ui.batchRefundReason.value) return;
    // 防御性校验：batchTargetRows 已按 canRefund 过滤，理论上不会出现以下状态；
    // 保留是为了兜底——若后端 canRefund 误判，避免脏数据直接提交到退款接口
    if (ui.batchType.value === 'refund' && batchTargetRows.value.some(item => ['refunded', 'approving', 'REFUNDED', 'APPROVING'].includes(item.refundState || ''))) {
      return message.warning('选中项包含不可退款单据');
    }
    let params = {};
    switch (ui.batchType.value) {
      case 'refund':
        {
          const screenshotUrls = ui.refundScreenshots.value.filter(f => f.status === 'done').map(f => f.url).filter(Boolean);
          params = {
            mode: ui.batchRefundMode.value.toUpperCase(),
            refundReason: ui.batchRefundReason.value,
            ...(ui.batchRefundMode.value === 'ratio' ? {
              ratioPercent: ui.batchRefundRatio.value
            } : {}),
            customerComplaintUrl: screenshotUrls.join(',')
          };
          break;
        }
      case 'reply':
        {
          const imageMediaIds = ui.batchReplyFiles.value.map(item => {
            var _item$response2;
            return (_item$response2 = item.response) === null || _item$response2 === void 0 ? void 0 : _item$response2.mediaId;
          }).filter(mediaId => !!mediaId);
          params = {
            content: ui.batchReplyContent.value,
            imageMediaIds
          };
          break;
        }
      default:
        params = {};
    }
    const done = await batchSubmit(ui.batchType.value, params, batchTargetRows.value);
    if (done) {
      ui.batchOpen.value = false;
      if (ui.batchType.value === 'reply') ui.revokeBatchReplyFiles();
    }
  };
  const copyValue = value => copy(String(value !== null && value !== void 0 ? value : ''));
  onMounted(async () => {
    await Promise.all([getFilterOptions(), getProductOptions(), getQuickReplyTemplates()]);
    await getStatistics();
    await getList();
    window.addEventListener('resize', ui.resizeTable);
  });
  onBeforeUnmount(() => window.removeEventListener('resize', ui.resizeTable));
  return {
    ui,
    columns,
    loading,
    detailLoading,
    pageNum,
    pageSize,
    toMoney,
    total,
    dataSource,
    filterForm,
    quickRanges,
    selectedRows,
    overviewList,
    exportList,
    filterOptions,
    historyList,
    currentComplaint,
    orderInfoList,
    replyTemplates,
    submitLoading,
    selectedRowKeys,
    refundReasons,
    problemTypeMap,
    refundStateMap,
    refundDisabledTip,
    complaintStateMap,
    search,
    reset,
    selectRows,
    handleOpenDetail,
    changePage,
    closeDetail,
    submitReply,
    submitResend,
    openRefund,
    submitRefund,
    submitReject,
    openBatch,
    submitBatch,
    batchTargetRows,
    batchRefundTotalAmount,
    copyValue
  };
};